// src/components/3D/BuildingMesh.jsx
import React, { useMemo } from 'react';
import { Text } from '@react-three/drei';
import * as THREE from 'three';

const BuildingMesh = React.memo(({ element, position }) => {
  const height = element.category === 'building' ? 
    (element.properties.maxFloors || 1) * 3 : 0.5;

  const windowPattern = useMemo(() => {
    const canvas = document.createElement('canvas');
    canvas.width = 256;
    canvas.height = 256;
    const ctx = canvas.getContext('2d');
    
    ctx.fillStyle = element.color;
    ctx.fillRect(0, 0, 256, 256);
    
    const windowSize = 16;
    const spacing = 32;
    
    for(let i = 0; i < 8; i++) {
      for(let j = 0; j < 8; j++) {
        ctx.fillStyle = Math.random() > 0.2 ? '#ffffff' : '#888888';
        ctx.fillRect(
          j * spacing + (spacing - windowSize) / 2,
          i * spacing + (spacing - windowSize) / 2,
          windowSize,
          windowSize
        );
      }
    }
    
    const texture = new THREE.CanvasTexture(canvas);
    texture.repeat.set(element.width/100, height/3);
    texture.wrapS = texture.wrapT = THREE.RepeatWrapping;
    return texture;
  }, [element.width, height, element.color]);

  return (
    <group position={[position[0], height/2, position[1]]}>
      <mesh castShadow receiveShadow>
        <boxGeometry args={[element.width/40, height, element.height/40]} />
        <meshPhongMaterial map={windowPattern} color={element.color} transparent opacity={0.9} />
      </mesh>
      
      <mesh position={[0, height/2 + 0.1, 0]} castShadow>
        <boxGeometry args={[element.width/40, 0.2, element.height/40]} />
        <meshPhongMaterial color="#333" />
      </mesh>

      <Text
        position={[0, height + 0.5, 0]}
        rotation={[-Math.PI/2, 0, 0]}
        fontSize={0.5}
        color="black"
        anchorX="center"
        anchorY="middle"
      >
        {element.type}
      </Text>
    </group>
  );
});

export default BuildingMesh;